import React, {lazy,Suspense} from 'react';
import ReactDOM from 'react-dom/client';
import store from './store/index'
import { Provider } from 'react-redux'
import './index.css'; 
import './api/api';
import reportWebVitals from './reportWebVitals';
import { privilegedSessionExpired } from './store/Reducers/authReducer';
import { BrowserRouter } from 'react-router-dom'; // Router əlavə olunur
const App = lazy(() =>import('./App'));

window.addEventListener('privileged-session-expired', () => {
  store.dispatch(privilegedSessionExpired())
})

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
<BrowserRouter>
<Provider store={store} >
      <Suspense fallback= 'loading...' >
        <App />
      </Suspense>
    </Provider>
</BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
